{
  "dismiss": "Elutasítás"
}